import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
	Container,
	Button,
	Col,
	Card,
	CardBody,
	CardTitle,
} from "reactstrap"
import { Link } from "react-router-dom"
import { ToastContainer } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withRouter } from "../../components/Common/withRouter"
import ChargeEditForm from "./ChargeEditForm";

// Utilities
import {
	createNotificationHelpers,
	updateStoreUsageCharges,
} from "../utils";
class ChargeEdit extends Component {
	constructor(props) {
		super(props)
		this.state = {
			store_domain: "",
			variable_charge: 2,
			fixed_charge: 0,
			loading: false,
			store_details: props.location?.state?.data?.store_details || {},
			store_status: "",
		}

		// Initialize notification helpers
		const notifications = createNotificationHelpers();
		this.notify_error = notifications.notify_error;
		this.notify_success = notifications.notify_success;
	}
	componentDidMount() {
		const locationState = this.props.location?.state;
		const data = locationState?.data || this.props.location?.data;
		if (data && data.store_domain) {
			const { store_domain, variable_charge, fixed_charge, store_details, store_status } = data;
			this.setState({
				store_domain,
				variable_charge: Number(variable_charge),
				fixed_charge: Number(fixed_charge),
				store_details: { ...store_details },
				store_status
			});
			return;
		}
		const params = new URLSearchParams(this.props.location?.search || '');
		const storeFromQuery = params.get('store');
		if (storeFromQuery) {
			this.setState({ store_domain: storeFromQuery });
		}
	}
	/**
	 * Handles form submission
	 */
	handleValidSubmit = async (e) => {
		e.preventDefault();
		const { store_domain, variable_charge, fixed_charge } = this.state;

		const success = await updateStoreUsageCharges(
			store_domain,
			variable_charge,
			fixed_charge,
			this.notify_error
		);

		if (success) {
			this.setState({ loading: true });
			this.notify_success("Usage Charge has been updated successfully!");
		}
	}

	handleInputChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value
		})
	}

	render() {
		const { store_domain, store_details, store_status, variable_charge, fixed_charge, loading } = this.state;
		return (
			<React.Fragment>
				<div className="page-content">
					<Helmet>
						<title>Veeper | AP - Usage Charge Edit</title>
					</Helmet>
					<Container fluid>
						<Breadcrumbs
							title={("XYZ Usage Charge Edit")}
							breadcrumbItem={("xxx Edit")}
						/>
						<ToastContainer />
						<Col md={12}>
							<Card>
								<CardBody>
									<CardTitle className="h4"></CardTitle>
									<Link to={{ pathname: "/merchant-details", search: store_domain ? `?store=${encodeURIComponent(store_domain)}` : undefined, state: { data: (store_details && Object.keys(store_details).length > 0) ? store_details : { store_domain }, storeStatus: store_status } }} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
										<Button className="btn btn-dark">
											<i className="fa fa-arrow-left"></i> Store Details
										</Button>
									</Link>

									<ChargeEditForm
										store_domain={store_domain}
										variable_charge={variable_charge}
										fixed_charge={fixed_charge}
										onInputChange={this.handleInputChange}
										onSubmit={this.handleValidSubmit}
									/>
								</CardBody>
							</Card>
						</Col>

					</Container>
				</div>
			</React.Fragment>
		)
	}
}

ChargeEdit.propTypes = {
	t: PropTypes.any
}
export default withRouter(ChargeEdit)
